import React, { useState, useEffect } from 'react';
import { 
  Box,  
  Typography, 
  Grid,
  useMediaQuery,
} from '@mui/material';
import { CustomButton, CustomTooltip, StandardChip, StatusChip } from '../../../v2/MUI_custom_component';
import HumbeeTabs from '../../../v2/MUI_custom_component/Tab';
import {  Sort } from '../../../components/icons';
import DynamicFilter, { FilterButton, SelectedFiltersDisplay } from '../../DyanamicFilter';
import IconReusable from '../../../components/IconReusable';
import ReusableMenu from '../../../v2/MUI_custom_component/Menu';
import GlassModal from '../../../v2/MUI_custom_component/Modal/GlassModal';
import RewardsCard from './RewardsCard';
import PerformanceChart from './PerformanceChart';
import { toast } from 'react-toastify';
import { getNetworkFilterAction, getNetworkPerformanceAction, getNetworkRewardAction } from '../API/Action';
import { useNavigate } from 'react-router-dom';
import StatusBadge from '../../../v2/MUI_custom_component/Badge/StatusBadge';
import { BRAND, getVerificationStatusLabel } from '../../../utils/settings';
import { toCapitalized } from '../../../v2/Utils/Capitalize';
import IllustrationWrapper from '../../Illustrration/IllustrationWrapper';
import NoDataFoundSvg from '../../Illustrration/components/NoDataFoundSvg';
import BenefitCard from './BenefitCard';
import CustomChip from '../../Components/CustomChip';
import { useSelector } from 'react-redux';

const NetworkCards = ({ role_image, networkCards, networkTypes, onTabChange, selectedTab: parentSelectedTab , badgeText, selectedCompanyEntity, selectedManufacturer, roleFilters = [] }) => {
  const isMobile = useMediaQuery('(max-width: 1024px)');
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(0);
  const [roleTab, setRoleTab] = useState(parentSelectedTab || 0); 
  const currentNetworkTypeId = networkTypes?.[roleTab]?.id;
  const currentRoleFilters = roleFilters.find(f => f.id === currentNetworkTypeId)?.filter_list || [];
  const [sortAnchorEl, setSortAnchorEl] = useState(null);
  // Set default sort to 'Recent sales' descending
  const [currentSort, setCurrentSort] = useState({ field: 'recent_sales', direction: 'desc' });
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [filteredNetworkCards, setFilteredNetworkCards] = useState(networkCards || []);
  const [appliedFilters, setAppliedFilters] = useState({});
  const [filterCount, setFilterCount] = useState(0);
  const [openDetailModal, setOpenDetailModal] = useState(false);
  const [selectedNetworkCard, setSelectedNetworkCard] = useState(null);
  const [networkDetailsData, setNetworkDetailsData] = useState(null);
  const [rewardsData, setRewardsData] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [loadingRewards, setLoadingRewards] = useState(false);
  const [loadingNetwork, setLoadingNetwork] = useState(false);
  const {
      selectedSupplier,
  } = useSelector(
    (state) => state.entityReducer
  );
  const sortMenuItems = [
    {
      label: 'Name: A-Z',
      value: 'name_asc',
      visible: true,
      onClick: () => handleSort('name', 'asc')
    },
    {
      label: 'Name: Z-A',
      value: 'name_desc',
      visible: true,
      onClick: () => handleSort('name', 'desc')
    },
    {
      label: 'Recent sales',
      value: 'recent_sales_desc',
      visible: true,
      onClick: () => handleSort('recent_sales', 'desc')
    },
    {
      label: 'DSP Sales: High to Low',
      value: 'dsp_sale_desc',
      visible: selectedSupplier === BRAND.DALMIA_CEMENT,
      onClick: () => handleSort('dsp_sale', 'desc')
    },
    {
      label: 'DSP Sales: Low to High',
      value: 'dsp_sale_asc',
      visible: selectedSupplier === BRAND.DALMIA_CEMENT,
      onClick: () => handleSort('dsp_sale', 'asc')
    },
    {
      label: 'Total sales: High to Low',
      value: 'ytd_sales_desc',
      visible: true,
      onClick: () => handleSort('ytd_sales', 'desc')
    },
    {
      label: 'Total sales: Low to High',
      value: 'ytd_sales_asc',
      visible: true,
      onClick: () => handleSort('ytd_sales', 'asc')
    },
    
  ];
  useEffect(() => {
    if (parentSelectedTab !== undefined && parentSelectedTab !== roleTab) {
      setRoleTab(parentSelectedTab);
    }
  }, [parentSelectedTab]);
  useEffect(() => {
    setFilteredNetworkCards(networkCards || []);
  }, [networkCards]);

  const applyFilters = (filters) => {
    setAppliedFilters(filters);
    let filtered = [...(networkCards || [])];

    // Use currentRoleFilters for filtering
    if (currentRoleFilters && Array.isArray(currentRoleFilters)) {
      currentRoleFilters.forEach(filterConfig => {
        const filterKey = filterConfig.key;
        const selectedOptions = filters[filterKey];
        if (filterConfig.type === 'text' && selectedOptions && typeof selectedOptions === 'string' && selectedOptions.trim() !== '') {
          const searchValue = selectedOptions.toLowerCase();
          filtered = filtered.filter(card => {
            // Try to match in card.details (by phone) or card.name
            return card.details?.some(detail =>
              detail.display_value?.toLowerCase().includes(searchValue)
            ) || card.name?.toLowerCase().includes(searchValue);
          });
        }
        else if (filterConfig.type === 'checkbox' && selectedOptions && Array.isArray(selectedOptions) && selectedOptions.length > 0) {
          filtered = filtered.filter(card => {
            const cardValue = card[filterKey];
            const defaultValue = getDefaultValueForFilter(filterKey);
            return selectedOptions.includes(cardValue || defaultValue);
          });
        }
        else if (filterConfig.type === 'radio' && selectedOptions && typeof selectedOptions === 'string' && selectedOptions.trim() !== '') {
          filtered = filtered.filter(card => {
            const cardValue = card[filterKey];
            const defaultValue = getDefaultValueForFilter(filterKey);
            return selectedOptions === (cardValue || defaultValue);
          });
        }
      });
    }

    setFilteredNetworkCards(filtered);

    // Count active filters
    let count = 0;
    Object.entries(filters).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length > 0) {
        count += value.length;
      } else if (typeof value === 'string' && value.trim() !== '') {
        count += 1;
      }
    });
    setFilterCount(count);
  };
  const getDefaultValueForFilter = (filterKey) => {
    const defaultValues = {
      'umang_utsav': 'not_qualified',
      'active_status': 'active',
      'verification_status': 'not_verified'
    };
    return defaultValues[filterKey] || '';
  };
  const handleSortClick = (event) => {
    setSortAnchorEl(event.currentTarget);
  };
  const handleCloseSortMenu = () => {
    setSortAnchorEl(null);
  };
  const handleSort = (field, direction) => {
    setCurrentSort({ field, direction });
    handleCloseSortMenu();
  };

  const applySorting = (cards) => {
    if (!currentSort.field) return cards;

    return [...cards].sort((a, b) => {
      let aValue, bValue;
      switch (currentSort.field) {
        case 'name':
          aValue = a.name?.toLowerCase() || '';
          bValue = b.name?.toLowerCase() || '';
          break;
        case 'dsp_sale':
          aValue = a.product_sales || 0;
          bValue = b.product_sales || 0;
          break;
        case 'ytd_sales':
          aValue = a.ytd_sales || 0;
          bValue = b.ytd_sales || 0;
          break;
        case 'recent_sales':
          aValue = a.last_transaction_date ? new Date(a.last_transaction_date) : new Date(0);
          bValue = b.last_transaction_date ? new Date(b.last_transaction_date) : new Date(0);
          break;
        default:
          return 0;
      }

      if (currentSort.direction === 'asc') {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      } else {
        return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
      }
    });
  };
  const clearFilters = () => {
    setFilteredNetworkCards(networkCards || []);
    setAppliedFilters({});
    setFilterCount(0);
  };
  const fetchNetworkDetails = async (network_id, network_esi, selectedManufacturer, selectedCompanyEntity) => {
      const payload = {
        manufacturer_id: selectedManufacturer,
        company_esi_id: selectedCompanyEntity,
        network_id: network_id,
        network_esi_id: network_esi
      };
      setLoadingNetwork(true);
      const { data, error, message } = await getNetworkPerformanceAction(payload);
      setLoadingNetwork(false);
      if (!error) {
          setNetworkDetailsData(data);
      } else {
        return toast.error(message);
      }
  };
  const fetchRewardsData = async (network_id, network_esi, selectedManufacturer, selectedCompanyEntity) => {
    const payload = {
        manufacturer_id: selectedManufacturer,
        company_esi_id: selectedCompanyEntity,
        network_id: network_id,
        network_esi_id: network_esi
      };
    setLoadingRewards(true);
    const { data, error, message } = await getNetworkRewardAction(payload);
    setLoadingRewards(false);
    if (!error) {
          setRewardsData(data);
    } else {
        return toast.error(message);
    }
  };
  const [ selectedNetworkESI, setSelectedNetworkESI] = useState(null);
  const handleViewDetails = (card) => {
    setSelectedNetworkCard(card);
    setOpenDetailModal(true);
    setSelectedNetworkESI(card.esi_id);
    
    const network_id = card.id;
    const network_esi = card.esi_id;
    fetchNetworkDetails(network_id, network_esi, selectedManufacturer, selectedCompanyEntity);
    fetchRewardsData(network_id, network_esi, selectedManufacturer, selectedCompanyEntity);
  };
  const handleCallNumber = (phoneNumber) => {
    if (phoneNumber) {
      const telUrl = `tel:${phoneNumber}`;
      try {
        window.open(telUrl, '_self');
      } catch (error) {
        navigator.clipboard.writeText(phoneNumber).then(() => {
          alert(`Phone number ${phoneNumber} copied to clipboard`);
        }).catch(() => {
          alert(`Contact: ${phoneNumber}`);
        });
      }
    } else {
      alert('Contact information not available');
    }
  };
  const handleContactCall = (card) => {
    const phoneDetail = card.details?.find(detail =>
      detail.display_name?.includes("Contact")
    );

    if (phoneDetail && phoneDetail.display_value) {
      handleCallNumber(phoneDetail.display_value);
    } else {
      alert(`Contact information not available for ${card.name}`);
    }
  };
  const removeSpecificFilter = (filterKey, optionKey) => {
    const updatedFilters = { ...appliedFilters };
    if (filterKey === 'search') {
      updatedFilters.searchQuery = '';
    } else if (optionKey) {
      const current = updatedFilters[filterKey] || [];
      if (Array.isArray(current)) {
        updatedFilters[filterKey] = current.filter(k => k !== optionKey);
      } else {
        updatedFilters[filterKey] = '';
      }
    } else {
      updatedFilters[filterKey] = '';
    }
    applyFilters(updatedFilters);
  };
  const roles = networkTypes ? 
    networkTypes.map(type => type.display_name.toLowerCase().replace(' ', '-')) :
    [...new Set(networkCards?.map(card => card.role) || [])];
    
  const roleLabels = {
    'influencer': 'Influencer',
    'sub-dealer': 'Sub Dealer'
  };
  

  const filteredCardsByRole = filteredNetworkCards?.filter(card => {
    if (!networkTypes) {
      return roles.length > 0 && roleTab < roles.length ? card.role === roles[roleTab] : true;
    }
    const currentNetworkType = networkTypes[roleTab];
    if (!currentNetworkType) return true;
    const currentRole = currentNetworkType.display_name.toLowerCase().replace(' ', '-');
    return card.role === currentRole;
  }) || [];
  const filteredCards = filteredCardsByRole.filter(card => {
    if (selectedTab === 0) return true;
    if (selectedTab === 1) return card.verification_status === 'Verified';
    return true;
  });
  const sortedAndFilteredCards = applySorting(filteredCards);
  const handleRoleTabChange = (event, newValue) => {
    setRoleTab(newValue);
    setSelectedTab(0);
    clearFilters();
    
    if (onTabChange) {
      onTabChange(newValue);
    }
  };
  const renderNetworkCard = (card, index, ) => (
    <Grid item xs={12} md={6}>
      <Box key={index} sx={{ background: '#fff', padding:1, borderRadius: 2 , position: 'relative',
        display: 'flex', flexDirection: 'column', gap: 1,
      }}>
        <Box sx={{ display: 'flex', gap: 1, }}>
          <Box sx={{
            backgroundColor: "#F7F7F7",
            borderRadius: {xs: 1, md: 2},
            width: {xs: '48px', md: '64px'},
            height: {xs: '48px', md: '64px'},
            // height: 'auto',
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
              <Box
                  component={'img'}
                  src={role_image}
                  alt="network"
                  sx={{ width: 32, height: 32, objectFit: "contain" }}
              />
          </Box>
          <Box sx={{ flex: 1 , display: 'flex', flexDirection: 'column', gap: 0 }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="labelD">
                {card.name}
              </Typography>
                <Box sx={{ position: 'absolute', right: 0 , zIndex:1, cursor: 'pointer', top: 0}}>
                  {card.active_status && (
                    <StatusBadge
                      label={card.active_status}
                      status={card.active_status}
                      variant="text"
                      size="medium"
                    />
                  )}
                </Box>
            </Box>
            <Box 
              sx={{ 
                display: 'flex', 
                alignItems: 'end',
                justifyContent: 'space-between'
              }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                {card.details?.map((detail, idx) => {
                  if (detail.display_name?.toLowerCase() === 'umang utsav' && card.umang_utsav !== 'qualified') {
                    return null;
                  }
                  
                  return (
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }} key={idx}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      {detail.display_name?.toLowerCase() === 'umang utsav' && card.umang_utsav === 'qualified' && (
                        <Box sx={{ display: 'flex', cursor: 'pointer', alignItems: 'center', justifyContent: 'center' }}>
                          <IconReusable name="Qualified" width={13} height={13} viewBox={'0 0 20 20'} color="#0081F2" />
                        </Box>
                      )}
                      <Typography
                        variant="labelM"
                        sx={{
                          color: '#666',
                          minWidth: (detail.display_name?.toLowerCase() === 'umang utsav' && card.umang_utsav === 'qualified') ? '100px' : '100px',
                        
                        }}
                      >
                        {detail.display_name}
                      </Typography>
                      </Box>
                      <Typography variant="p3">
                        {detail.display_value}
                      </Typography>
                    </Box>
                  );
                })}
              </Box>
              
              <Box 
                sx={{ cursor: 'pointer', mr: 2 }}
                onClick={() => handleContactCall(card)}
              >
                <IconReusable name="Call1" size={24} color="#995A00" />
              </Box>
            </Box>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'end' }}>
            {card.role === 'influencer' && (
              <StatusBadge 
                label={getVerificationStatusLabel(card.verification_status)} 
                status={card.verification_status} 
                size={isMobile ? 'small' : 'medium'}
              />
            )}
            {card.influencer_type && (
              <CustomChip
                size={isMobile ? 'small' : 'default'}
                label={card.influencer_type}
                selected={false}
                variant="outlined"
              />
            )}
          </Box>
          <Box>
            <CustomButton
              variant="text"
              label={'View Details'}
              color='primary'
              size={isMobile ? 'small' : 'default'}
              onClick={() => handleViewDetails(card)}
            />
          </Box>
        </Box>
        {card.kyc_verified_show && (
          <Box sx={{ mt: 2, textAlign: 'center' }}>
            <CustomButton
              fullWidth
              variant="filled"
              color='primary'
              label='Verify KYC'
            />
          </Box>
        )}
      </Box>
    </Grid>
  );
  const networkDetailModal = () => (
    <GlassModal
        open={openDetailModal}
        onClose={() => setOpenDetailModal(false)}
        showHeader={true}
        title="Buyer Details"
        scrollable={true}
        maxWidth="600px"
        zIndex={2}
    >
      {(loadingDetails || loadingRewards) ? (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography>Loading network details...</Typography>
        </Box>
      ) : (networkDetailsData || rewardsData) ? (
        <Box sx={{ pb: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', }}>
              <Box sx={{ display: 'flex', gap: 1, flexDirection: 'column'}}>
                  <Typography variant="h2">
                    {networkDetailsData?.buyer_details?.name || 'N/A'}
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                     <Typography variant="labelM">Phone</Typography>
                     <Typography variant="p3">{networkDetailsData?.buyer_details?.phone || 'N/A'}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                     <Typography variant="labelM">Address</Typography>
                     <Typography variant="p3">
                       {networkDetailsData?.buyer_details?.address || 'N/A'} {networkDetailsData?.buyer_details?.city ? `${networkDetailsData.buyer_details.city}, ` : ''}{networkDetailsData?.buyer_details?.state || ''} {networkDetailsData?.buyer_details?.pincode ? `- ${networkDetailsData.buyer_details.pincode}` : ''}
                     </Typography>
                  </Box>
              </Box>
              <Box
                sx={{ mr: 2, cursor: 'pointer' }}
                onClick={() => handleCallNumber(networkDetailsData?.buyer_details?.phone)}
              >
                <IconReusable name="Call1" size={24} color="#995A00" />
              </Box>
          </Box>
          {networkDetailsData?.performance_history && (
            <PerformanceChart
              performanceData={networkDetailsData.performance_history}
              hideDspSales={selectedSupplier !== BRAND.DALMIA_CEMENT}
            />
          )}
          {networkDetailsData?.sell_products && (
            <Box>
              <CustomButton
                fullWidth
                variant="filled"
                color="primary"
                label="Sell Products"
                onClick={() => navigate('/inventory')}
              />
            </Box>
          )}
          
          {networkDetailsData?.network && networkDetailsData.network.length > 0 && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 ,}}>
              <Typography variant="h2">
                Network
              </Typography>
              <Box sx={{ display: 'flex', bgcolor: '#FFF', py: 2, px: 1, borderRadius: 2 }}>
                {networkDetailsData.network.map((item, index) => (
                  <Box 
                    key={index}
                    sx={{ 
                      textAlign: 'center',
                      flex: 1,
                      borderRight: index < networkDetailsData.network.length -1 ? '1px solid #D9D9D9' : 'none',
                      px: 0.5,
                    }}
                  >
                    <Typography variant="labelM" sx={{ color: '#666' }}>
                      {item.display_name}
                    </Typography>
                    <Typography variant="h3">
                      {item.value}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          )}
          {rewardsData?.benefits && rewardsData.benefits.length > 0 && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography variant="h2">
                Benefits
              </Typography>
              <Grid container spacing={2}>
                {rewardsData.benefits.map((benefit, index) => (
                  <Grid item xs={6} key={index}>
                    <BenefitCard
                      benefit={benefit} 
                      selectedNetworkESI={selectedNetworkESI}
                      selectedCompanyEntity={selectedCompanyEntity}
                      selectedManufacturer={selectedManufacturer}
                      sx={{ minHeight: 'unset', background: 'transparent', border: '1px solid #FFF' }}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}
          {rewardsData?.rewards && rewardsData.rewards.length > 0 && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography variant="h2">
                Rewards
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1}}>
                {rewardsData.rewards.map((reward, index) => (
                  <RewardsCard key={index} reward={reward} selectedNetworkESI={selectedNetworkESI} selectedCompanyEntity={selectedCompanyEntity} selectedManufacturer={selectedManufacturer} />
                ))}
              </Box>
              
            </Box>
          )}
        </Box>
      ) : (
        <Box sx={{ textAlign: 'center', py: 4,zIndex:2 }}>
          <Typography>No data available</Typography>
        </Box>
      )}
    </GlassModal>
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        gap: {xs: 1, md: 2 },
        mb: 1
      }}>
        {roles.length > 0 && (
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <HumbeeTabs
              data={roles}
              currentTab={roleTab}
              onChange={handleRoleTabChange}
              getTabLabel={(role, index) => {
                return networkTypes ? 
                  networkTypes[index]?.display_name || role :
                  (roleLabels[role] || role);
              }}
              getTabKey={(role) => role}
              visibleTabCount={isMobile ? 2 : 0}
              tabType="dashed"
              tabVariant={isMobile ? 'small' : 'default'}
              />
          </Box>
        )}

        <Box sx={{ display: 'flex',}}>
          <CustomButton 
            endIcon={<Sort width={'18px'} />}
            variant="text"
            label={'Sort'}
            color='neutral'
            size={isMobile ? 'small' : 'medium'}
            onClick={handleSortClick}
          />
          <FilterButton 
            onOpenFilter={() => setFilterModalOpen(true)}
            activeFilterCount={filterCount}
            label="Filter"
            variant="text"
            size={isMobile ? 'small' : 'medium'}
            color='neutral'
          />
        </Box>
      </Box>
      <SelectedFiltersDisplay
        appliedFilters={appliedFilters}
        filterConfig={currentRoleFilters}
        onRemoveFilter={removeSpecificFilter}
        onClearAll={clearFilters}
        showClearAll={false}
      />

      {/* Network Cards List */}
      {sortedAndFilteredCards?.length === 0 ? (
        <Box sx={{ mt: 4}}>
        <IllustrationWrapper 
          illustration={<NoDataFoundSvg />}
          title=""
          subtitle=""
        />
        </Box>
      ) : (
        <Grid container spacing={2}>
          {sortedAndFilteredCards?.map((card, index) => renderNetworkCard(card, index))}
        </Grid>
      )}
      <ReusableMenu
        anchorEl={sortAnchorEl}
        open={Boolean(sortAnchorEl)}
        onClose={handleCloseSortMenu}
        menuItems={sortMenuItems.filter(item => item.visible)}
        selectedValue={`${currentSort.field}_${currentSort.direction}`}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{ mt: 1 }}
      />

      <DynamicFilter
        open={filterModalOpen}
        onClose={() => setFilterModalOpen(false)}
        title="Filter"
        filterConfig={currentRoleFilters}
        initialFilters={appliedFilters}
        onApply={applyFilters}
        onClear={clearFilters}
        showSearch={true}
        showDateRange={false}
        showSort={false}
      />
      
      {/* Network Details Modal */}
      {networkDetailModal()}
    </Box>
  );
};

export default NetworkCards;